/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiBase from '@here/lui-base'
import scopedCss from 'lui-card.scss'
import template from 'lui-card.html'

export default class LuiCard extends LuiBase {
  static get is() {
    return 'lui-card'
  }

  static get css() {
    return scopedCss
  }

  static get template() {
    return template
  }

  onConnected() {
    super.onConnected()
  }

  onDisconnected() {
    super.onDisconnected()
  }

  // Sets orientation for lui-card.
  orientationChanged(oldValue, newValue) {
    this.setOrientation(newValue)
  }

  // Sets custom card height for lui-card
  cardheightChanged(oldValue, newValue) {
    const luiCard = this.luiCardControl
    luiCard.style.height = newValue
  }

  // Sets custom card width for lui-card
  cardwidthChanged(oldValue, newValue) {
    const luiCard = this.luiCardControl
    luiCard.style.width = newValue
  }

  // sets orientation for lui-card. Default is vertical orientation
  setOrientation(orientation) {
    if (orientation === '' || (orientation !== 'vertical' && orientation !== 'horizontal')) {
      orientation = 'vertical'
    }
    const luiCard = this.luiCardControl
    luiCard.classList = []
    luiCard.classList.add(`lui-card-${orientation}`)
  }

  get luiCardControl() {
    return this.shadowRoot.querySelector('div')
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-card/lui-card.js
// module id = 373
// module chunks = 0 1 36